import { render, staticRenderFns } from "./EvaluatorEvaluationsListView.vue?vue&type=template&id=0b615f42&scoped=true"
import script from "./EvaluatorEvaluationsListView.vue?vue&type=script&lang=js"
export * from "./EvaluatorEvaluationsListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b615f42",
  null
  
)

export default component.exports